<template>
  <div>
    <v-select
      v-model="storeId"
      :hint="storeAddress"
      :items="stores"
      item-text="storeName"
      item-value="id"
      label="Store"
      persistent-hint
      single-line
      :menu-props="{ bottom: true, offsetY: true }"
      dense
    />
  </div>
</template>

<script>
export default {
  name: "StoreList",
  data: () => ({
    stores: [],
    storeAddress: null,
  }),
  computed: {
    storeId: {
      get() {
        return this.$store.getters.storeIdAdmin;
      },
      set(val) {
        this.$store.dispatch("storeInfo/setStoreIdAdmin", val);
      },
    },
  },
  watch: {
    "$store.getters.storeInfo": function () {
      this.storeAddress = this.$store.getters.storeInfo.storeAddress;
    },
    "$store.getters.storeIdAdmin": function () {
      location.reload();
    },
  },
  async beforeCreate() {
    const { data } = await axios.get("/app/stores");
    this.stores = data.data;
    if (this.$store.getters.storeIdAdmin) {
      this.$store.dispatch("storeInfo/loadStoreInfoAdmin");
      this.storeId = this.$store.getters.storeIdAdmin;
    } else {
      this.$store.dispatch("storeInfo/setStoreIdAdmin", this.stores[0].id);
    }
  },
};
</script>
<style lang="scss">
.select-store .v-text-field__details {
  display: none !important;
}
</style>
